export default {
  subscriptionPlans: [],
}
